/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
import React from 'react';
import { getChildrenText } from '../utils/getChildrenText';
var AKTag = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.tag' */
  '@atlaskit/tag').then(function (module) {
    return {
      default: module.SimpleTag
    };
  });
});
var colorDict = {
  default: 'standard',
  green: 'green',
  blue: 'blue',
  red: 'red',
  purple: 'purple',
  grey: 'grey',
  teal: 'teal',
  yellow: 'yellow',
  'green-light': 'greenLight',
  'blue-light': 'blueLight',
  'red-light': 'redLight',
  'purple-light': 'purpleLight',
  'grey-light': 'greyLight',
  'teal-light': 'tealLight',
  'yellow-light': 'yellowLight'
};
var mapColorToAK = function mapColorToAK(color) {
  return colorDict[color];
};
export var Tag = function Tag(_ref) {
  var _ref$forgeDoc = _ref.forgeDoc,
    props = _ref$forgeDoc.props,
    children = _ref$forgeDoc.children;
  var _ref2 = props,
    _ref2$color = _ref2.color,
    color = _ref2$color === void 0 ? 'default' : _ref2$color;
  var akColor = mapColorToAK(color);
  return /*#__PURE__*/React.createElement(AKTag, {
    color: akColor,
    text: getChildrenText(children)
  });
};